import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-reservation-header',
  templateUrl: './reservation-header.component.html',
  styleUrls: ['./reservation-header.component.scss']
})
export class ReservationHeaderComponent implements OnInit {
  @Input('step') step:any;
  @Input('dates') dates:any;
  public internacional:any;
  public _moment: any;

  constructor() {
    this._moment = moment;
    if(sessionStorage.getItem("internacional")){
      this.internacional = sessionStorage.getItem("internacional").includes("true");
    }
   }

  ngOnInit() {
  }

}
